import {BaseViewModel} from "../../../infrastructure/models/base-view-model";
import {NewsDomainModel} from "../../../domain/news/models/news.domain-model";
import {NewsFetchImageRequestParams} from "../../../domain/news/models/news.fetch-image-request-params";
import {BaseUrlModel} from "../../../infrastructure/models/link/base-url-model";
import {BaseLinkModelSettings} from "../../../infrastructure/models/link/base-link-model-settings";
import {NewsSourceDomainModel} from "../../../domain/news/models/news-source.domain-model";
import {NewsWidgetNewsSourceViewModel} from "./news-widget.news-source.view-model";
import {NEWS} from "../news-widget.consts";
import {NewsWidgetItemMetaData} from "./news-widget.item.meta-data";

export class NewsWidgetItemViewModel extends BaseViewModel {
  domainModel: NewsDomainModel;
  time: String;
  title: String;
  publishRelativeTime: String;
  url: String;
  isSmallView: Boolean;
  isMagazine: Boolean;
  sourceId: Number;

  constructor(domainModel: NewsDomainModel, publishRelativeTime: String, isPreview: Boolean, isSmallView: Boolean, position: Number) {
    super(domainModel);

    this.title = domainModel.title;
    this.publishRelativeTime = publishRelativeTime;
    this.url = domainModel.url;
    this.isMagazine = domainModel.isMagazine;
    this.isPreview = isPreview;
    this.isSmallView = isSmallView;
    this.position = position;
  }

  get image(): NewsFetchImageRequestParams {
    let sizes = NEWS.IMAGE_SIZE.default;
    if(this.isSmallView){
      sizes = NEWS.IMAGE_SIZE.small_view;
      if(this.isPreview){
        sizes = NEWS.IMAGE_SIZE.small_view_preview
      }
    }
    else if(this.isPreview){
      sizes = NEWS.IMAGE_SIZE.preview;
    }

    return new NewsFetchImageRequestParams(this.domainModel.image, sizes.width, sizes.height)
  }

  get linkModel(): BaseUrlModel {
    const setting = new BaseLinkModelSettings();
    setting.shouldOpenNewTab = true;

    const decodeUrl: String = decodeURIComponent(this.url)
      .replace(NEWS.URLS_CONFIG.PARAM.screen, NEWS.URLS_CONFIG.VALUE.screen)
      .replace(NEWS.URLS_CONFIG.PARAM.context, NEWS.URLS_CONFIG.VALUE.context);

    return new BaseUrlModel(decodeUrl, this.isMagazine, setting);
  }

  get source(): NewsWidgetNewsSourceViewModel {
    return new NewsSourceDomainModel(this.domainModel.source);
  }

  get metaDataModel(): NewsWidgetItemMetaData {
    const metaDataModel = new NewsWidgetItemMetaData(this.position, this.domainModel);

    return metaDataModel;
  }
}
